import { render, staticRenderFns } from "./advertise-list.vue?vue&type=template&id=132f4060&scoped=true&"
import script from "./advertise-list.vue?vue&type=script&lang=js&"
export * from "./advertise-list.vue?vue&type=script&lang=js&"
import style0 from "./advertise-list.vue?vue&type=style&index=0&id=132f4060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132f4060",
  null
  
)

export default component.exports